var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 16L1.12055 12.0245C0.399971 10.8017 0.0205806 9.41034 0.0205806 7.98107C0.0205806 3.58029 3.60476 0 8.01032 0C12.4159 0 16 3.58029 16 7.98107C16 12.3819 12.4159 15.9621 8.01032 15.9621C6.63757 15.9621 5.29339 15.6111 4.10427 14.9446L0 16ZM4.3141 13.4927L4.55866 13.6418C5.59543 14.2741 6.78902 14.6083 8.01032 14.6083C11.6685 14.6083 14.6447 11.6353 14.6447 7.98107C14.6447 4.32682 11.6685 1.35385 8.01032 1.35385C4.3521 1.35385 1.3759 4.32682 1.3759 7.98107C1.3759 9.25435 1.73818 10.4908 2.42347 11.5568L2.58817 11.813L1.94288 14.1024L4.3141 13.4927Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.7658 4.26647L5.24737 4.23824C5.08453 4.22937 4.9248 4.28372 4.80172 4.39053C4.55038 4.60855 4.1485 5.03005 4.02507 5.57931C3.84099 6.39829 4.12546 7.40115 4.8617 8.404C5.59795 9.40686 6.96999 11.0114 9.39617 11.6967C10.178 11.9176 10.793 11.7687 11.2675 11.4655C11.6433 11.2253 11.9024 10.8399 11.9958 10.4041L12.0786 10.0179C12.1049 9.8952 12.0425 9.77064 11.9283 9.71809L10.1762 8.91135C10.0624 8.859 9.92755 8.89209 9.85105 8.99112L9.1632 9.88186C9.11125 9.94915 9.0223 9.97583 8.94198 9.94765C8.47093 9.78228 6.89303 9.12215 6.02723 7.4562C5.98968 7.38395 5.99902 7.29625 6.05228 7.23462L6.70966 6.47496C6.77683 6.39739 6.79379 6.28833 6.75343 6.19406L5.99817 4.42899C5.95796 4.33502 5.86786 4.27204 5.7658 4.26647Z",
  fill: "white"
});

function SvgWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp-icon.3acccea483eaf5b8b49c36afefb79db6.svg";
export { ForwardRef as ReactComponent };